export function mapDegreeToStep(degree: number): number {
    let step = 0;
    switch (degree) {
        case 90:
            step = 1;
            break;
        case 180:
            step = 2;
            break;
        case 270:
            step = 3;
            break;
        default:
            break;
    }
    return step;
}